import request from '../utils/request'

export function sdAppListPageApi (data) {
  return request({
    url: 'api/sd/appListPage',
    method: 'post',
    data
  })
}

export function sdAddApi (data) {
  return request({
    url: 'api/sd/addSD',
    method: 'post',
    data
  })
}

export function sdUpdateApi (data) {
  return request({
    url: 'api/sd/updateSD',
    method: 'post',
    data
  })
}

export function sdInfoApi (sdId) {
  return request({
    url: `api/sd/info/${sdId}`,
    method: 'get'
  })
}

export function updateInfoApi (sdId) {
  return request({
    url: `api/sd/updateInfo?sdId=${sdId}`,
    method: 'get'
  })
}

export function arsSdVisitLastApi (sdId, visitType) {
  // visitType=(0-门店维护,1-门店拓展,2-reorder
  return request({
    url: `api/sdVisit/lastVisit/${sdId}?visitType=${visitType}`,
    method: 'get'
  })
}

export function sdVisitAddOrUpdateApi (data) {
  return request({
    url: 'api/sdVisit/addOrUpdate',
    method: 'post',
    data
  })
}

export function sdVisitInfoApi (visitId) {
  return request({
    url: `api/sdVisit/info/${visitId}`,
    method: 'get'
  })
}

export function eventUpdateSdInfoApi (customerId, eventId, params) {
  return request({
    url: `api/event/updateSdInfo/${customerId}?eventId=${eventId}`,
    method: 'get'
  })
}
